import React from "react";
import Card from "../../../components/Global/Card";
import { AiOutlineTeam } from "react-icons/ai";
import RegisterColaboratorForm from "../../../components/Forms/RegisterColaboratorForm";
import GoBack from "../../../components/Utils/GoBack";
import { useParams } from "react-router-dom";

function EditColaborator() {
    const { id } = useParams();

  return (
    <div className="flex flex-col w-full gap-3">
      <GoBack path="/colaboradores"/>
      <Card title="Cadastro de Colaborador" icon={<AiOutlineTeam className="w-[25px] h-[25px]" />}>
        <div className="p-4 flex flex-col gap-5 w-full">
          <RegisterColaboratorForm userId={id}/>
        </div>
      </Card>
    </div>
  );
}

export default EditColaborator;
